import React, { useState } from 'react';
import './Hero.css';
import PartnershipModal from './PartnershipModal';

function Hero() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="heading-xl">
          <span className="Dealer">Your Dealer,</span>
          <br/>
          <span>Our Credit!</span>
          </h1>
          <p className="body-lg">
            <span>Now no more dealer outstanding & time waste in payment follow-ups… Introduce quick credit to your dealers and focus more on your business not on payment.</span>
          </p>
          <h3  className="prabhat hero-subtitle">For Brands | Manufacturer | Wholesaler | Distributor</h3>
          <div className="hero-buttons">
            <button className="btn btn-primary" onClick={() => setIsModalOpen(true)}>
              Apply Now
              <img src="/icons/arrow-right.png" alt="Apply for credit" className="btn-icon" />
            </button>
            {/* <button className="btn btn-secondary">
              View Requirement
            </button> */}
          </div>
          <div className="hero-badges hero-badges-custom">
            <div className="badge">
              <img src="/icons/checkmark.png" alt="Secure Encryption" className="badge-icon" />
              <span className="caption">Bank Level Encryption</span>
            </div>
            <div className="badge">
              <img src="/icons/clock.png" alt="Quick Process" className="badge-icon" />
              <span className="caption">Digital Quick Process</span>
            </div>
          </div>
        </div>
        <div className="hero-image">
          <div className="placeholder-box">
            <img src="/images/hand.jpg" alt="Partnering for business growth" />
          </div>
        </div>
      </div>
      <PartnershipModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </section>
  );
}

export default Hero;